import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { setInitialStoreState } from '../../../../common';
import { PublicTrackingItemFacade } from './public-tracking-item.facade';
import { Observable, of } from 'rxjs';
import { ItemTrackingContentType, ItemTrackingContentTypeFromSAP } from '../models/public-tracking.model';

@Injectable({
  providedIn: 'root',
})
export class PublicTrackingItemGuard  {
  constructor(private publicTrackingItemFacade: PublicTrackingItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const trackingContentType =
      ItemTrackingContentTypeFromSAP.DN in route.queryParams ? ItemTrackingContentType.DN : ItemTrackingContentType.HU;
    const itemId: string = route.queryParams[ItemTrackingContentTypeFromSAP[trackingContentType]];
    const sapIdPropertyName = 'sapId';
    const sapId: string = sapIdPropertyName in route.queryParams ? route.queryParams[sapIdPropertyName] : null;

    if (itemId && trackingContentType) {
      this.publicTrackingItemFacade.loadAll({ itemId, trackingContentType, sapId });
    }

    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.publicTrackingItemFacade);
  }
}
